import {getPlanFamily, getPlanRank} from './PlanActions';

// Plan limits from Skua's GET /plans (`plan.limits`, from the plan's allowances), as short lines for plan
// cards. Only limits the plan really has are returned, so a plan without limits shows none.
const formatCount = value => new Intl.NumberFormat('en-US').format(value);

const formatStorage = megabytes => {
  const trim = value => String(Math.round(value * 10) / 10);
  if (megabytes >= 1024 * 1024) {
    return `${trim(megabytes / (1024 * 1024))} TB`;
  }
  if (megabytes >= 1024) {
    return `${trim(megabytes / 1024)} GB`;
  }
  return `${megabytes} MB`;
};

// Attribution comes with Starter and above (Community and Basic get the rest of GrowthKit)
const hasAttribution = planKey => getPlanFamily(planKey) === 'marketplace' && getPlanRank(planKey) >= 1;

// The two product kits every plan includes; email, forms and analytics limits will be added here later.
// planKey: the Skua plan unique_id (or its upgrade name) the card is for.
export const planKitLines = (t, planKey) => [
  hasAttribution(planKey)
    ? t('workspace.plans.kit_growth', 'GrowthKit (Email, Forms, Analytics, Attribution)')
    : t('workspace.plans.kit_growth_basic', 'GrowthKit (Email, Forms, Analytics)'),
  t('workspace.plans.kit_operate', 'OperateKit (ERP + commerce)'),
];

// Community and Basic: a line telling the owner what the next plan adds (null for every other plan)
export const planUpgradeHint = (t, planKey) => {
  const key = String(planKey || '').toLowerCase();
  const isCommunity = key.includes('community');
  // 'basic' is the upgrade panel's short name before prices load; sold as 2025-superstarter
  const isBasic = key === 'basic' || (getPlanFamily(key) === 'marketplace' && getPlanRank(key) === 0);
  return isCommunity || isBasic
    ? t('workspace.plans.attribution_from_starter', 'Attribution: available from Starter')
    : null;
};

export const planLimitLines = (limits, t) => {
  if (!limits) {
    return [];
  }
  const lines = [];
  const count = (key, translationKey, fallback) => {
    if (typeof limits[key] === 'number') {
      lines.push(t(translationKey, {count: formatCount(limits[key])}, fallback));
    }
  };
  count('listings', 'workspace.plans.limit_listings', 'Up to {count} listings');
  count('accounts', 'workspace.plans.limit_accounts', 'Up to {count} accounts');
  count('external_users', 'workspace.plans.limit_users', 'Up to {count} users');
  if (typeof limits.storage_mb === 'number') {
    lines.push(t('workspace.plans.limit_storage', {size: formatStorage(limits.storage_mb)}, '{size} storage'));
  }
  return lines;
};
